import { render, staticRenderFns } from "./ConfigAlertLark.vue?vue&type=template&id=67374d23&scoped=true"
import script from "./ConfigAlertLark.vue?vue&type=script&lang=js"
export * from "./ConfigAlertLark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67374d23",
  null
  
)

export default component.exports